import React from "react";
import { Snackbar, Alert, AlertProps, Button } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { StatusCredential } from "libLegacy/api/auth";

import { mapCredentialStatusToAlertProps } from "logic/MyBills";

const useStyles = makeStyles()((theme) => ({
  card: {
    boxShadow: theme.shadow,
    flexWrap: "wrap",
    padding: theme.spacing(2),

    "& > *": {
      margin: 0,
    },

    "& >:first-of-type": {
      marginRight: theme.spacing(1),
    },

    "& >:last-child": {
      justifyContent: "flex-end",
      width: "100%",

      "& > button": {
        textTransform: "uppercase",
      },
    },

    "&>.MuiAlert-message": {
      flex: 1,
    },
  },
}));

export const CredentialAlert = ({ status, onClose }: CredentialAlertProps) => {
  const { message, requiresCredentialUpdate, ...props } =
    mapCredentialStatusToAlertProps(status);
  const history = useHistory();
  const { classes } = useStyles();

  const actionButtons = (
    <>
      {requiresCredentialUpdate && (
        <Button
          onClick={() =>
            history.push("/onboarding/energy-operator", {
              returnToDashboard: true,
            })
          }
        >
          {props.actionText || "Preencher"}
        </Button>
      )}
      <Button color="secondary" onClick={onClose} aria-label="fechar alerta">
        <Close />
      </Button>
    </>
  );

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={true}
    >
      <Alert {...props} className={classes.card} action={actionButtons}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export type CredentialAlertProps = {
  status: Exclude<StatusCredential, "VALIDATED">;
  onClose: AlertProps["onClose"];
};
